import Vue from 'vue'
import vueResource from 'vue-resource'
import Axios from 'axios'

Vue.prototype.$axios = Axios;  //在Vue的原型上添加$axios方法
Vue.use(vueResource)

const axios = Axios;

export default function request(url, params = { method: 'get', data: {} }) {
	params.header = {

	}
	return fetch(url, params);
}

function fetch(url, params) {
	return new Promise((resolve, reject) => {

		let result = {
			success: false,
			data: false,
			msg: '',
		}

		const responseType = url.indexOf('orderExport') !== -1 ? 'blob' : '';
		axios({
			url: url,
			headers: params.header,
			method: params.method,
			data: params.data,
			responseType: responseType,
			timeout: 10000,
			success: (res) => {
				console.log(res);
			},
			fail: (err) => {
				console.log(err);
			}
		}).then((r) => {
			if (r.status === 200) {
				if (url.indexOf('orderExport') !== -1) {
					resolve(r.data);
				}
				if (r.data.success || r.data.statusCode === 200) {
					//接口请求数据成功
					result.success = true;
					if (r.data.forwardUrl && (typeof r.data.forwardUrl) === 'string') {
						//判断是否xml, 是的话直接返回内容, 不需要json.parse
						if (r.data.forwardUrl.substring(0, 5) !== '<?xml') {
							r.data.forwardUrl = JSON.parse(r.data.forwardUrl);
						}
					}
					result.data = r.data.data ? r.data.data : r.data.forwardUrl;
					resolve(result);
				} else {
					//接口请求数据失败
					result.success = false;
					result.data = r.data.data ? r.data.data : r.data.forwardUrl;
					result.msg = r.data.msg ? r.data.msg : r.data.message;
					resolve(result);
				}
			} else {
				console.log('========================= request.js');
				console.log(r);
				console.log('====================================');
				result.msg = r.data;
				resolve(result);
			}
		}).catch((e) => {
			console.log('request catch ==================');
			if (e.toString() === 'Error: timeout of 10000ms exceeded') {
				result.msg = '请求超时, 请检查网络状况重新操作';
			} else {
				result.msg = e;
			}
			resolve(result);
		});
	})
}



// WEBPACK FOOTER //
// ./src/utils/request_api.js